/**
 * Clerk loads its client JS at runtime from the instance's frontend API
 * (clerk.<domain>). If that fetch never completes — a firewall doing TLS
 * inspection (corporate or public/airport wifi), a VPN, CSP, a bad publishable
 * key, or a Clerk outage — `isLoaded` stays false forever, and every
 * `if (!isLoaded) return <Loading/>` gate hangs on a permanent spinner.
 *
 * This hook bounds that wait. It returns the full `useAuth()` result plus a
 * `timedOut` flag that flips true once Clerk has failed to load within `ms`,
 * so callers can render an actionable fallback instead of spinning forever.
 */

import { useAuth } from '@clerk/react';
import { useEffect, useState } from 'react';

export function useClerkReady(ms = 8000) {
  const auth = useAuth();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (auth.isLoaded) return;
    const t = setTimeout(() => setTimedOut(true), ms);
    return () => clearTimeout(t);
  }, [auth.isLoaded, ms]);

  return { ...auth, timedOut };
}
